import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Renders an employee name as a clickable link (for ADMIN/MANAGER)
 * that navigates to their Work Diary page.
 * Falls back to a plain span for EMPLOYEEs.
 */
export default function EmployeeLink({ userId, name, className = '' }) {
  const navigate = useNavigate();
  const { isManager } = useAuth();

  if (!isManager || !userId) {
    return <span className={className}>{name}</span>;
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/work-diary?userId=${userId}`);
      }}
      className={`hover:text-blue-600 hover:underline text-left transition-colors ${className}`}
    >
      {name}
    </button>
  );
}
